BuyButton = window.BuyButton ?= {}

MagicEventBus = require 'magic-event-bus/lib/frizzle.js'
BuyButton.View = require '../frontend/views/buy_button'

BuyButton.resetMultiOptionLink = (payload) ->
  $(window).on 'pageshow', ->
    if $('.multi-option-breakout').length
      $wrapper = '.multi-option-breakout'
      buyLink = $('#buy-link').attr('href')

    return unless buyLink

    linkWithNoQuantity = BuyButton.removeQuantityParam(buyLink)
    $newSelectedInput = $($wrapper + ' input[value="' + linkWithNoQuantity + '"]')
    $newSelectedInput.prop('checked', true)

BuyButton.removeQuantityParam = (url) ->
  url.split(/&quantity=[0-9]+[^&]?/).join('')

BuyButton.init = (payload, done) ->
  {buyButton, iframeLogin, variations, inlineVariations, goodsWarranty} = payload

  @eventBus = new MagicEventBus()

  if iframeLogin? and not iframeLogin.authenticated and not iframeLogin.disabledOnBuyButton
    handleBuyButton = ->
      IframeLogin.openModal BuyButton.view.$buyButton.attr 'href'
      {stopTheBus: true}

    @eventBus.board('buy_button_clicked', handleBuyButton)(999)

  $ =>
    if buyButton.multiOptionEnabled
      BuyButton.resetMultiOptionLink payload

    @view = new BuyButton.View
      multiOptionEnabled: buyButton.multiOptionEnabled
      multiOptionInline: buyButton.multiOptionInline
      buyButtonEnabled: buyButton.buyButtonEnabled
      hasVariations: variations? || inlineVariations?
      goodsWarranty: goodsWarranty

    done()

module.exports = BuyButton



// WEBPACK FOOTER //
// ./modules/buy_button/desktop_2016/frontend/buy_button.coffee